import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PaymentPageContainer from './PaymentPageContainer';
import { actions } from './PaymentPageContainer.actions';
import {
    getHeaderNames,
    getPaymentDetails,
    getCountries
} from './PaymentPageContainer.selectors';

const mapStateToPropsSelectors = createStructuredSelector({
    headerNames: getHeaderNames,
    paymentDetails: getPaymentDetails,
    countries: getCountries
});

const PaymentPageContainerComponent = connect(
    function mapStateToProps(state) {
        return {
            ...mapStateToPropsSelectors(state),
            paymentMethods: state.paymentMethods,
            paymentSystems: state.paymentSystems,
            allowPaymentSystems: state.allowPaymentSystems,
            loading: state.paymentDetails.loading || !state.paymentMethods.length,
            totalPages: state.paymentDetails.total
        };
    },
    null
)(PaymentPageContainer);

export default PaymentPageContainerComponent;
